<template>
  <div v-if="customer">
    <div class="tile is-ancestor">

      <div class="tile is-parent is-6">
        <grid-box title="Profil">
          <div class="field">
            <label class="label">Namn</label>
            <input class="input" type="text" v-model="customer.name" readonly>
          </div>

          <div class="field">
            <label class="label">Organisationsnummer</label>
            <input class="input" type="text" v-model="customer.organizationNumber" readonly>
          </div>

          <div class="field">
            <label class="label">Gatuadress</label>
            <input class="input" type="text" v-model="customer.mainAddress.address1" readonly>
          </div>

          <!-- <div class="field">
            <label class="label">Adress 2</label>
            <input class="input" type="text" v-model="customer.mainAddress.address2">
          </div> -->

          <div class="field">
            <label class="label">Postkod</label>
            <input class="input" type="text" v-model="customer.mainAddress.postalCode" readonly>
          </div>

          <div class="field">
            <label class="label">Postort</label>
            <input class="input" type="text" v-model="customer.mainAddress.city" readonly>
          </div>

          <div class="field">
            <label class="label">Område</label>
            <input class="input" type="text" v-model="customer.mainAddress.area" readonly>
          </div>

        </grid-box>
      </div>
    </div>
    <button class="button is-primary" @click="save()">Spara</button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GridBox from '../../../../boxes/GridBox.vue'

export default {
  components: {
    GridBox
  },

  data () {
    return {
      customer: null
    }
  },

  computed: {
    ...mapState('auth', ['user', 'status']),

    ...mapState({
      productStructure: state => state.meta.all.productStructure
    })
  },

  methods: {
    ...mapActions('customers', ['update', 'getById']),

    save () {
      this.update(this.customer)
    }
  },

  created () {
    this.getById(this.user.customerId).then(customer => {
      this.customer = customer.result
    })
  }
}
</script>

<style scoped lang="scss">
.margin-top {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Dashboard/CustomerViews/CustomerInfo.vue